import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageStateService {
  getState<T>(key: string): T | null {
    const storage = this.getStorage();
    if (!storage) {
      return null;
    }

    const rawState = storage.getItem(key);
    if (!rawState) {
      return null;
    }

    try {
      return JSON.parse(rawState) as T;
    } catch {
      return null;
    }
  }

  setState<T>(key: string, state: T): void {
    const storage = this.getStorage();
    if (!storage) {
      return;
    }

    storage.setItem(key, JSON.stringify(state));
  }

  clearState(key: string): void {
    const storage = this.getStorage();
    if (!storage) {
      return;
    }

    storage.removeItem(key);
  }

  private getStorage(): Storage | null {
    if (typeof globalThis === 'undefined') {
      return null;
    }

    try {
      return globalThis.localStorage;
    } catch {
      return null;
    }
  }
}
